import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'
import OptionSelectView from '../views/OptionSelectView'

const OptionSelectController = () => {

  const eventId = useMetaStore((state) => state.eventId)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isAdmin = searchParams.get('admin')
  const finalized = useMetaStore((state) => state.finalized)

  useEffect(() => {
    if (!eventId) {
      navigate('/error')
    }

    if (isAdmin === 'admin') {
      useMetaStore.getState().setIsAdmin(true)
    }
  }, []) // Empty dependency array ensures useEffect runs only once after the initial render

  const onSubmit = (e) => {
    navigate('/groupentry')
  }

  const watchLeaderboard = (e) => {
    navigate('/leaderboard')
  }

  return (
    <div>
      <OptionSelectView
        onSubmit={onSubmit}
        watchLeaderboard={watchLeaderboard}
        finalized={finalized}
      />
    </div>
  )
}

export default OptionSelectController
